export default __webpack_public_path__ + "assets/images/e6a3f1e9225472ff550db9b8240946e8.svg";